import React, { useCallback } from "react";
import { Button } from "antd";
import { observer } from "mobx-react";
import { DOWNLOAD } from "../../constants/translates";
import { Download as IDownload } from "./Interfaces";
import { DOWNLOAD_XML } from "../../constants/authorize";
import Authorize from "../Authorize";

interface Props {
  store: IDownload;
}

const Download: React.FC<Props> = ({ store }) => {
  const onDownloadHandler = useCallback(() => {
    store.downloadXml();
  }, [store]);

  return (
    <Authorize permission={DOWNLOAD_XML}>
      <Button
        type="primary"
        className="download-btn"
        onClick={onDownloadHandler}
        disabled={store.selectedRows.length === 0}
        size="small"
      >
        {DOWNLOAD}
      </Button>
    </Authorize>
  );
};

export default observer(Download);
